import type { AnnotationLabelT } from '../../../common/types/types';
import { ANNOTATION_TYPE } from '../../labelling/constants';
import type { AnnotationType } from '../../labelling/types/annotations.type';

/**
 * A label configured for exactly one tool is fixed at task-setup time and can't disagree
 * with its own geometry, unlike an annotation's own annotationType (sourced from the
 * backend's annotationSummary), which can come back stale/wrong for a given annotation —
 * prefer the label's tool in that unambiguous case. When a label has no tool configured,
 * or supports more than one shape, its tools list can't tell us which shape was actually
 * drawn, so trust the annotation's own recorded type instead.
 */
export function resolveAnnotationType(annotationLabel: Pick<AnnotationLabelT, 'tools'>, metaAnnotationType: AnnotationType): AnnotationType {
  const labelTool = annotationLabel.tools?.[0];
  return annotationLabel.tools?.length === 1 && labelTool && labelTool in ANNOTATION_TYPE ? (labelTool as AnnotationType) : metaAnnotationType;
}